import { useEffect } from 'react';

import { useLazyQuery } from '@apollo/client';

import VivaExamLatestResultSummaryQuery from 'bundles/academic-integrity/components/viva-exam/api/VivaExamLatestResultSummaryQuery.graphql';
import type {
  VivaExamLatestResultSummaryQueryQuery as VivaExamLatestResultSummaryType,
  VivaExamLatestResultSummaryQueryQueryVariables as VivaExamLatestResultSummaryVariables,
} from 'bundles/academic-integrity/components/viva-exam/api/__generated__/VivaExamLatestResultSummaryQuery';

export const useGetVivaExamLatestResultSummary = (assignmentId: string, userId: number) => {
  const [getVivaExamLatestResultSummary, { data, error, loading, refetch }] = useLazyQuery<
    VivaExamLatestResultSummaryType,
    VivaExamLatestResultSummaryVariables
  >(VivaExamLatestResultSummaryQuery, {
    variables: { assignmentId, userId },
    context: { clientName: 'gatewayGql' },
  });

  useEffect(() => {
    getVivaExamLatestResultSummary();
  }, [getVivaExamLatestResultSummary]);

  return {
    vivaExamResultSummary: data?.VivaExam?.queryLatestExamResultSummary,
    refetchVivaExamResultSummary: refetch,
    errorFromLatestResultSummary: error,
    loading,
  };
};
